<template>
  <v-snackbar
    v-model="snackbar.visible"
    :color="snackbar.color"
    :multi-line="snackbar.mode === 'multi-line'"
    :timeout="snackbar.timeout"
    :top="snackbar.position === 'top'"
  >
    <v-row>
      <v-layout align-center pr-4>
        <v-icon class="pr-1">{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <!-- <div>
            <strong>{{ snackbar.title }}</strong>
          </div> -->
          <div class="px-1">{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn icon @click="snackbar.visible = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-row>
  </v-snackbar>
</template>

<script>
export default {
  name:'EosSnackbar',
  data() {
    return {
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: "top",
        text: "aa",
        timeout: 1000,
        title: null,
        visible: false,
      },
    };
  },
  methods: {
    SnackbarShow(type, msg) {
      if (!type) return;
      
      switch (type) {
        case "error":
          this.snackbar = {
            color: "error",
            icon: "mdi-alert-circle",
            mode: "multi-line",
            position: "top",
            timeout: 1000,
            title: "Error",
            visible: true,
          };
          break;
        case "info":
          this.snackbar = {
            color: "info",
            icon: "mdi-information",
            mode: "multi-line",
            position: "top",
            timeout: 0,
            title: "Information",
            text: "This is useful and is quite a long message, and won't be hidden automatically. You need to dismiss this by clicking the 'X' on the right.",
            visible: true,
          };
          break;
        case "success":
          this.snackbar = {
            color: "success",
            icon: "mdi-check-circle",
            mode: "multi-line",
            position: "top",
            timeout: 1000,
            title: "Success",
            text: "That worked, hoorah.",
            visible: true,
          };
          break;
        case "warning":
          this.snackbar = {
            color: "warning",
            icon: "mdi-alert",
            mode: "multi-line",
            position: "top",
            timeout: 1000,
            title: "Warning",
            text: "You probably shouldn't have seen that, oops.",
            visible: true,
          };
          break;
      }

      ////console.log('msg:'+msg);
      this.snackbar.text = msg;
    },
  },
};
</script>

<style>
</style>